export function getLinkValue(link, key) {
  if (!link) return 0;

  if (link[key].hasOwnProperty('polarity')) {
    return link[key].polarity === 1 ? link[key].value : -link[key].value;
  }

  return link[key].value;
}
